import Axios from '@/http'

export default {
  businessSystemSettingApi() {
    return new Promise((resolve, reject) => {
      Axios.post('setting/businessSystemSetting').then((res) => {
        return resolve(res)
      })
    })
  }
}
